import SimpleRow from './view'

export default SimpleRow
